var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_9","data-name":"Ellipse 9","cx":"12","cy":"12","r":"12","fill":"#fff","key":0}),React.createElement("path",{"id":"yt_logo","d":"M100.217,86.754A2.006,2.006,0,0,0,98.8,85.34,47.073,47.073,0,0,0,92.55,85a47.768,47.768,0,0,0-6.251.335,2,2,0,0,0-1.415,1.42,22.334,22.334,0,0,0,0,7.7A2,2,0,0,0,86.3,95.871a47.781,47.781,0,0,0,6.251.335,47.8,47.8,0,0,0,6.252-.335,2.006,2.006,0,0,0,1.415-1.415,20.886,20.886,0,0,0,.333-3.851A21.259,21.259,0,0,0,100.217,86.754ZM90.95,93.005v-4.8l4.157,2.4Z","transform":"translate(-80.55 -78.6)","fill":"#254c5b","key":1})]);
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Youtube;

Youtube.default = Youtube;
